import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 移交 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 作废 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 退回 ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }

import { ref, unref, onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router'
import { ElMessageBox } from 'element-plus';
import { CtAuditDialog, CtStampApplyDialog, CtStampSureDialog, UploadSignFile } from '../dialogs/Index';
import RejectDialog from '../dialogs/rejectDialog.vue'
import TransferDialog from '../dialogs/transferDialog.vue'
import ContractWriter from '../components/0_ContractWriter.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute()

const state = reactive({
    isApporove: false,
})

const contract = ref<any>()

const writerRef = ref<ComponentRef<typeof ContractWriter>>()
const auditRef = ref<ComponentRef<typeof CtAuditDialog>>()
const stampApplyRef = ref<ComponentRef<typeof CtStampApplyDialog>>()
const stampSureRef = ref<ComponentRef<typeof CtStampSureDialog>>()
const uploadFileRef = ref<ComponentRef<typeof UploadSignFile>>()
const rejectDialogRef = ref<ComponentRef<typeof RejectDialog>>()
const transferDialogRef = ref<ComponentRef<typeof TransferDialog>>()

/* 审批保存按钮 */
const onAuditBtnClick = () => {
    /* 根据状态调整，2：审批，3：用印申请，10：用印确认，9：待上传(入档) */

    const ctData = unref(contract)

    /* 合同审批 */
    if (ctData.status == 2) {
        unref(auditRef)?.showDialog(ctData)
    }

    /* 用印申请 */
    if (ctData.status == 3) {
        unref(stampApplyRef)?.showDialog(ctData)
    }

    /* 合同入档 */
    if (ctData.status == 9) {
        unref(uploadFileRef)?.showNotify(ctData)
    }

    /* 用印确认 */
    if (ctData.status == 10) {
        unref(stampSureRef)?.showDialog(ctData)
    }
}

const actions = {
    /* 审批退回or作废处理 */
    reject: (isCancel: boolean) => {
        const ctData = unref(contract)
        const rejectDialog = unref(rejectDialogRef)

        if (isCancel) {
            ElMessageBox.confirm(`是否作废当前合同(${ctData.no})？`, "警告", { lockScroll: false, confirmButtonText: "确定", cancelButtonText: "取消", type: 'warning' })
                .then(() => {
                    rejectDialog?.showDialog(ctData, isCancel);
                });
        } else {
            rejectDialog?.showDialog(ctData, isCancel);
        }
    },
    /* 合同移交 */
    transfer: () => {
        const ctData = unref(contract)
        const transferDialog = unref(transferDialogRef)
        ElMessageBox.confirm(`是否移交当前合同(${ctData.no})？`, "警告", { lockScroll: false, confirmButtonText: "确定", cancelButtonText: "取消", type: 'warning' })
            .then(() => {
                transferDialog?.showDialog(ctData);
            });
    },
}

/* 检查是否可以显示审批按钮 */
const loadSuccess = (data: any) => {
    contract.value = data
}

const onRefresh = (success: boolean) => {
    if (success) {
        state.isApporove = true
    }
}

onMounted(() => {
    const writer = unref(writerRef);
    writer?.methods.setFormData(query.contractId as string)
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ContractWriter, {
      ref_key: "writerRef",
      ref: writerRef,
      "is-preview": true,
      showprogress: true,
      "show-upload": false,
      titles: `合同审批`,
      onOnSuccess: loadSuccess
    }, {
      Options: _withCtx(() => [
        (contract.value && !_unref(state).isApporove)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (contract.value.status == 2)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "info",
                    style: {"width":"80px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (actions.transfer())),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (contract.value.status == 10)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "info",
                    style: {"width":"80px"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (actions.reject(true))),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "danger",
                style: {"width":"80px"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (actions.reject(false))),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"width":"80px"},
                onClick: onAuditBtnClick,
                size: "small"
              }, {
                default: _withCtx(() => [
                  (contract.value.status == 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "审批"))
                    : _createCommentVNode("", true),
                  (contract.value.status == 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "用印申请"))
                    : _createCommentVNode("", true),
                  (contract.value.status == 10)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "用印确认"))
                    : _createCommentVNode("", true),
                  (contract.value.status == 9)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "合同入档"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(CtAuditDialog), {
      ref_key: "auditRef",
      ref: auditRef,
      onRefresh: onRefresh
    }, null, 512),
    _createVNode(_unref(CtStampApplyDialog), {
      ref_key: "stampApplyRef",
      ref: stampApplyRef,
      onRefresh: onRefresh
    }, null, 512),
    _createVNode(_unref(CtStampSureDialog), {
      ref_key: "stampSureRef",
      ref: stampSureRef,
      onRefresh: onRefresh
    }, null, 512),
    _createVNode(_unref(UploadSignFile), {
      ref_key: "uploadFileRef",
      ref: uploadFileRef,
      onRefresh: onRefresh
    }, null, 512),
    _createVNode(RejectDialog, {
      ref_key: "rejectDialogRef",
      ref: rejectDialogRef,
      onRefresh: onRefresh
    }, null, 512),
    _createVNode(TransferDialog, {
      ref_key: "transferDialogRef",
      ref: transferDialogRef,
      onRefresh: onRefresh
    }, null, 512)
  ], 64))
}
}

})